<template>
  <div v-loading.fullscreen.lock="true"></div>
</template>

<script>
export default {
  async created() {
    const user = await this.$store.dispatch('user/getUser')
    if (user) {
      this.$store.dispatch('user/goToDefaultPage')
    } else {
      this.$router.push({ name: 'login' })
    }
  },
}
</script>
